interface StepperProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  label?: string
  className?: string
}

function Stepper({ value, onChange, min = 0, max = 13, label, className = '' }: StepperProps) {
  return (
    <div className={`flex items-center justify-between rounded-xl bg-ink/25 p-[5px] ${className}`}>
      <button
        type="button"
        aria-label="Færre"
        onClick={() => onChange(Math.max(min, value - 1))}
        className="h-[calc(48px*var(--scale))] w-[calc(48px*var(--scale))] rounded-[10px] bg-text-2/15 text-[1.5em]"
      >
        −
      </button>
      <div>
        <b className="block text-center font-mono text-[1.6em]">{value}</b>
        {label && <small className="block text-center text-[0.7rem] text-text-2">{label}</small>}
      </div>
      <button
        type="button"
        aria-label="Flere"
        onClick={() => onChange(Math.min(max, value + 1))}
        className="h-[calc(48px*var(--scale))] w-[calc(48px*var(--scale))] rounded-[10px] bg-text-2/15 text-[1.5em]"
      >
        +
      </button>
    </div>
  )
}

export default Stepper
